var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "buttonDimensions" },
        [
          _c(
            "b-button",
            {
              staticClass: "greenBtn noteIcon",
              attrs: { title: "Ansi Notes Template" },
              on: {
                click: function ($event) {
                  return _vm.getAnsiNotes()
                },
              },
            },
            [_c("fa", { attrs: { icon: ["fas", "cog"], size: "sm" } })],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "AnsiNotesModal",
            title: "ANSI Notes Template",
            "title-tag": "b",
            size: "lg",
            "content-class": "menu-bg-blue-transparent-modal nt-modal",
            "header-close-variant": "light",
            "hide-footer": "",
          },
        },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                { staticClass: "py-2" },
                [
                  _c("b-col", { staticClass: "col-sm-12 px-5" }, [
                    _c(
                      "div",
                      { staticClass: "field px-5" },
                      [
                        _c("label", { attrs: { for: "Notes" } }, [
                          _vm._v("Note *"),
                        ]),
                        _vm._v(" "),
                        _c("b-form-textarea", {
                          attrs: { name: "note", autocomplete: "off" },
                          model: {
                            value: _vm.form.note,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "note", $$v)
                            },
                            expression: "form.note",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.formSubmitErrors.length
                ? _c(
                    "b-container",
                    {
                      staticClass: "px-5",
                      attrs: { id: "formSubmitErrorsWindow" },
                    },
                    [
                      _c("b-col", { staticClass: "text-center" }, [
                        _c("span", [
                          _c("b", [
                            _vm._v("Please correct the following error(s):"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-group" },
                            _vm._l(_vm.formSubmitErrors, function (error) {
                              return _c(
                                "div",
                                {
                                  key: error,
                                  staticClass: "alert alert-danger",
                                },
                                [
                                  _c("li", { staticClass: "list-group-item" }, [
                                    _vm._v(_vm._s(error)),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.submitSuccess
                ? _c(
                    "b-row",
                    {
                      staticClass: "p-2",
                      attrs: { id: "formSubmitSuccessWindow" },
                    },
                    [
                      _c("b-col", { staticClass: "text-center" }, [
                        _c(
                          "span",
                          { staticClass: "ml-3" },
                          [
                            _c("b", { staticClass: "alert alert-success" }, [
                              _vm._v(_vm._s(this.submitSuccess)),
                            ]),
                            _vm._v(" "),
                            _c("fa", {
                              attrs: { icon: ["fas", "window-close"] },
                              on: {
                                click: function ($event) {
                                  return _vm.submitSuccessHide()
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "p-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn-md",
                          attrs: { variant: "primary", type: "submit" },
                          on: {
                            click: function ($event) {
                              return _vm.checkForm()
                            },
                          },
                        },
                        [_vm._v("\n            Submit\n          ")]
                      ),
                      _vm._v(" "),
                      this.updateEntryID
                        ? _c(
                            "b-button",
                            {
                              staticClass: "btn-md m-3",
                              attrs: { variant: "primary", type: "submit" },
                              on: {
                                click: function ($event) {
                                  return _vm.clearNotes()
                                },
                              },
                            },
                            [_vm._v("\n            Clear\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-container",
            [
              _c("vue-bootstrap4-table", {
                attrs: {
                  rows: _vm.notesRows,
                  columns: _vm.notesColumns,
                  config: _vm.config,
                  classes: _vm.classes,
                },
                scopedSlots: _vm._u([
                  {
                    key: "update",
                    fn: function (props) {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "info" },
                            on: {
                              click: function ($event) {
                                return _vm.editEntry(props.row)
                              },
                            },
                          },
                          [
                            _c("fa", {
                              attrs: {
                                icon: ["fas", "pencil-alt"],
                                size: "lg",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "delete",
                    fn: function (props) {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteEntry(props.row)
                              },
                            },
                          },
                          [
                            _c("fa", {
                              attrs: { icon: ["fas", "minus"], size: "lg" },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }